import { type AtlasStoredItemRow } from "@/components/ecv2/components/whiteboardEC/schema/canvas/canvasTypes";

export const ATLAS_GHOST_FILL = "color-mix(in oklch, var(--muted) 30%, transparent)";
export const ATLAS_GHOST_STROKE = "color-mix(in oklch, var(--border) 60%, transparent)";

export const ATLAS_GHOST_PREVIEW_ITEM_ID = "atlas_ghost_preview";

export function applyAtlasGhostStyle<TKey extends string, TPayload extends Record<string, unknown>>(
  item: AtlasStoredItemRow<TKey, TPayload>
): AtlasStoredItemRow<TKey, TPayload> {
  return {
    ...item,
    style: {
      ...item.style,
      fill: ATLAS_GHOST_FILL,
      stroke: ATLAS_GHOST_STROKE,
      textColor: "transparent",
    },
  };
}
